export const FORM_DRAFT_KEYS = {
  personalInfo: 'resumeBuilder.formDraft.personalInfo',
  workExperience: 'resumeBuilder.formDraft.workExperience',
  educationSkills: 'resumeBuilder.formDraft.educationSkills',
  missingInfo: 'resumeBuilder.formDraft.missingInfo',
  jobDescription: 'resumeBuilder.jobDescriptionDraft',
  chatInput: 'resumeBuilder.formDraft.chatInput',
} as const;

export type FormDraftName = keyof typeof FORM_DRAFT_KEYS;

const canUseLocalStorage = () => (
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
);

export function readFormDraft<T>(name: FormDraftName, fallback: T): T {
  if (!canUseLocalStorage()) return fallback;

  try {
    const rawDraft = window.localStorage.getItem(FORM_DRAFT_KEYS[name]);
    if (!rawDraft) return fallback;
    return JSON.parse(rawDraft) as T;
  } catch (error) {
    const rawDraft = window.localStorage.getItem(FORM_DRAFT_KEYS[name]);
    if (typeof fallback === 'string' && typeof rawDraft === 'string') {
      return rawDraft as T;
    }
    console.warn(`Unable to read ${name} draft`, error);
    return fallback;
  }
}

export function writeFormDraft(name: FormDraftName, value: unknown) {
  if (!canUseLocalStorage()) return;

  try {
    window.localStorage.setItem(FORM_DRAFT_KEYS[name], JSON.stringify(value));
  } catch (error) {
    console.warn(`Unable to save ${name} draft`, error);
  }
}

export function clearFormDraft(name: FormDraftName) {
  if (!canUseLocalStorage()) return;

  window.localStorage.removeItem(FORM_DRAFT_KEYS[name]);
}

export function clearResumeBuilderFormDrafts() {
  if (!canUseLocalStorage()) return;

  Object.values(FORM_DRAFT_KEYS).forEach((key) => {
    window.localStorage.removeItem(key);
  });
}
